import {all, setContext} from "redux-saga/effects";
import authSagas from "./Auth";
import notesSagas from "./Notes";
import applicationsSagas from "./Application";
import devicesSagas from "./Device";
import minisitesSagas from "./Minisite";
import logsSagas from "./Logs";
import zonesSagas from "./Zone";
import userPoolClientsSagas from "./UserPoolClient";
import deviceBatchsSagas from "./DeviceBatch";
import meshNetworksSagas from "./MeshNetwork";
import webSocketSagas from "./Websocket";

import {client} from "../../apollo/client";

export default function* rootSaga(getState) {
  yield setContext({ client });

  yield all([
    authSagas(),
    notesSagas(),
    applicationsSagas(),
    devicesSagas(),
    minisitesSagas(),
    logsSagas(),
    zonesSagas(),
    userPoolClientsSagas(),
    deviceBatchsSagas(),
    meshNetworksSagas(),
    webSocketSagas()
  ]);
}
